import { EVENT_VIEW_HITS } from '~~/constants/googleTagManager';

export const buildViewHitsTags = ({
  userToken,
  index,
  objectIDs,
}: {
  userToken?: string,
  index: string,
  objectIDs: string[]
}) => ({
  event: EVENT_VIEW_HITS,
  userToken,
  index,
  objectIDs,
});
